import useSurveyController from '../shared/use-survey-controller';

export default function useQuizletController() {
  // Use a fixed version for the quizlet survey
  const surveyVersion = 'quizlet1.0.0';

  const surveyController = useSurveyController({
    surveyVersion,
    onModalViewed: () => {
      // Turn off analytics for the quizlet survey. Should use page view instead.
      return;
    },
  });

  return {
    ...surveyController,
  };
}
